import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-04e8380b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cx-text-area-content" }
const _hoisted_2 = { class: "cx-position-bottom" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = { class: "cx-text-area-wrapper" }
const _hoisted_5 = ["disabled", "placeholder", "readonly"]
const _hoisted_6 = { class: "cx-text-area-validation-wrapper" }
const _hoisted_7 = {
  key: 0,
  class: "cx-text-area-validation"
}

import CxLabel from '@/components/CxLabel.vue';
import { useVuelidate, ValidationArgs } from '@vuelidate/core';
import { computed, ref, reactive, watch, Ref, WritableComputedRef } from 'vue';

interface Props {
  modelValue?: string,
  validationRules?: ValidationArgs<unknown> | Ref<ValidationArgs<unknown>>
  disabled?: boolean
  placeholder?: string
  label?: string
  readonly?: boolean
  tooltip?: string,
  showErrors?: boolean,
  immediatelyShowErrors?: boolean,
  onValidated?: Function
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CxTextArea',
  props: {
    modelValue: {},
    validationRules: {},
    disabled: { type: Boolean },
    placeholder: { default: '' },
    label: {},
    readonly: { type: Boolean, default: false },
    tooltip: {},
    showErrors: { type: Boolean, default: true },
    immediatelyShowErrors: { type: Boolean, default: false },
    onValidated: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

// State for validation
const state = reactive({
  modelValue: props.modelValue
});

const initalizeVuelidate = () => {
  return props.validationRules !== undefined ? useVuelidate(props.validationRules, state) : useVuelidate();
};
let v$ = initalizeVuelidate();

const innerValue = ref(props.modelValue ? `${props.modelValue}` : '');
const isInputValid = ref(true);
const errorMessage = ref('');
const isTooltipActive = ref(false);

const onBlur = () => {
  if (!props.immediatelyShowErrors && v$.value.$errors.length) {
    isInputValid.value = false;
    errorMessage.value = v$.value.$errors[0].$message.toString();
  } else if (!props.immediatelyShowErrors && v$.value.$errors.length === 0) {
    isInputValid.value = true;
    errorMessage.value = '';
  }
};

watch(() => (props.validationRules), () => {
  v$ = initalizeVuelidate();
  v$.value.$validate();
  if (v$.value.$errors.length) {
    isInputValid.value = false;
    errorMessage.value = v$.value.$errors[0].$message.toString();
  } else {
    isInputValid.value = true;
    errorMessage.value = '';
  }
});

watch(() => (props.modelValue), (newValue) => {
  state.modelValue = newValue;
});

watch(innerValue, (newValue) => {
  state.modelValue = newValue;
  if (props.immediatelyShowErrors && v$.value.$errors.length) {
    isInputValid.value = false;
    errorMessage.value = v$.value.$errors[0].$message.toString();
  } else if (props.immediatelyShowErrors && v$.value.$errors.length === 0) {
    isInputValid.value = true;
    errorMessage.value = '';
  }
  if (!props.readonly) {
    emit('update:modelValue', newValue);
  }
  if (props.onValidated && !props.disabled) props.onValidated(newValue);
});


return (_ctx: any,_cache: any) => {
  const _directive_cx_tooltip = _resolveDirective("cx-tooltip")!

  return (_openBlock(), _createElementBlock("div", {
    class: "cx-text-area",
    onMouseenter: _cache[1] || (_cache[1] = ($event: any) => (isTooltipActive.value=true)),
    onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (isTooltipActive.value=false))
  }, [
    (_ctx.label)
      ? (_openBlock(), _createBlock(CxLabel, {
          key: 0,
          label: _ctx.label
        }, null, 8, ["label"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createElementVNode("div", {
          class: _normalizeClass(["cx-text-area-container", { 'cx-text-area-container--error': _unref(v$).modelValue && !isInputValid.value }]),
          disabled: _ctx.disabled || null
        }, [
          _createElementVNode("div", _hoisted_4, [
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((innerValue).value = $event)),
              disabled: _ctx.disabled,
              placeholder: _ctx.placeholder,
              readonly: _ctx.readonly,
              onBlur: onBlur
            }, "\n            ", 40, _hoisted_5), [
              [_vModelText, innerValue.value]
            ])
          ])
        ], 10, _hoisted_3),
        _createElementVNode("div", _hoisted_6, [
          (!isInputValid.value && _ctx.showErrors)
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(errorMessage.value), 1))
            : _createCommentVNode("", true)
        ])
      ])), [
        [_directive_cx_tooltip, {
          text: _ctx.tooltip,
          show: isTooltipActive.value && _ctx.tooltip !== undefined,
          position: 'top-left',
          offsetTop: -5,
          maxWidth: 400,
        }]
      ])
    ])
  ], 32))
}
}

})